module.exports = __webpack_public_path__ + "img/radar_grid.20fe168b.svg";